import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { SeamVisionlineEntrance } from './get-seam-visionline-user'

type GetSeamVisionlineEntrancesRequest = {
  buildingId: number
}

export const getSeamVisionlineEntrancesQueryKey = (data: GetSeamVisionlineEntrancesRequest) => [
  'useGetSeamVisionlineEntrances',
  data,
]

const getSeamVisionlineEntrances = async (data: GetSeamVisionlineEntrancesRequest) => {
  const response = await authAPI.get<SeamVisionlineEntrance[]>(
    `/building/${data.buildingId}/seam-visionline/entrances`,
  )
  return response.data
}

export const useGetSeamVisionlineEntrances = (
  data: GetSeamVisionlineEntrancesRequest,
  enabled = true,
) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getSeamVisionlineEntrances(data),
    queryKey: getSeamVisionlineEntrancesQueryKey(data),
  })
